/* global process */
var devMode = process && process.env.NODE_ENV === 'development';
var config = {};

try {
	config = require(devMode ? './config.dev' : './config.prod');
}
catch(e) {
	console.warn('Please create a file named src/config/config.dev.js');
}

export default Object.assign({
  defaultUrl: 'school/demo/schedules/2016_2017',
  feature_flags: {
    cohort_selection: true,
    core_vs_noncore_layers: false
  }
}, config);


/** WEBPACK FOOTER **
 ** ./src/config/config.js
 **/